import './multiline-placeholder.less';

export const multilinePlaceholderComponentModule = angular
  .module('Q.components.forms.multiline-placeholder', [])

  .directive('multilinePlaceholder', function () {
    return {
      restrict: 'A',
      link(scope, elem, attr) {
        let placeholder = angular.element(
          '<div class="multiline-placeholder-element"></div>',
        );
        placeholder.text(attr.multilinePlaceholder);
        elem.attr('placeholder', '');
        elem[0].parentNode.insertBefore(placeholder[0], elem[0]);

        let updateEmpty = () => placeholder.toggleClass('empty', !elem.val());
        elem.on('keyup keypress blur change', updateEmpty);
        scope.$applyAsync(updateEmpty);
      },
    };
  });
